import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import View from './AdvancedSearchView';
import { requestAdvancedSearchClubs } from '../../../modules/club/actions';

function mapStateToProps(state) {
  return {
    clubs: state.advancedSearchClubs
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestAdvancedSearchClubs
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/components/Search/Advanced/AdvancedSearch.js